import React, { useEffect, useContext } from "react"
import api from "../api/api"
import Context from "../utils/Context"
import RobotSelector from "./RobotSelector"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faRobot } from '@fortawesome/free-solid-svg-icons'
import { watchDiagnostic, watchBattery, watchEndOfMission, mapFeedInfo, watchRobotPosition, watchForkHeight, watchLoad, watchPalletHeight, watchPalletWeight, watchZoneStatus, watchLocalizationConfidence } from "../utils/ROS/ROSFunctions"

export default function Network() {

  const context = useContext(Context)

  const fetchMaps = async () => {
    if (context.settings.fmsConnection) {
      let res

      res = await api.fetchMaps({ syncFMS: true })

      console.log('MAPS:', res)

      if (res?.data) context.actions.setMaps(res.data)
    }
  }
  const fetchAreas = async () => {
    const res = await api.fetchAreas();
    if (res) {
      const importedValue = res?.data.find(area => area._id === context.robotInfo?.areaId)
      context.actions.setLevelValue(importedValue?.levelValues)
      context.actions.setForkDiff(importedValue?.forkDiff)
    }
  }

  useEffect(() => {
    //if(!context.isRobotConnected) fetchMaps()
  }, [context.selectedRobot, context.isRobotConnected])

  useEffect(() => {
    if (context.isRobotConnected) {
      watchDiagnostic(context)
      watchBattery(context)
      watchEndOfMission(context)
      mapFeedInfo(context)
      watchRobotPosition(context)
      watchForkHeight(context)
      watchLoad(context)
      watchPalletHeight(context)
      watchPalletWeight(context)
      watchZoneStatus(context)
      watchLocalizationConfidence(context)
      if (context.settings.fmsConnection) fetchAreas()
    }
  }, [context.isRobotConnected])
  // first load actions
  /*useEffect(() => {
    // connect to FMS
    const connectToFms = async () => {
      console.log('yo')

      if (context.settings.fmsConnection) {
        // connect
        try {
          console.log("connecting to fms...")
          const res = await api.connect("fi-remote", "wgo")
          //const res = await api.connect("fi-rafael", "rafael321")
          //const res = await api.connect("fi-remote", "(KiWi)mgu[369]remote")
          //const res = await api.connect("fi-fi-remote", "wgomfrofl")
          console.log(res)
          if (res) console.log("connected to fms")
          if (!res) console.log("invalid credentials")

          console.log(res.data.token)
          if (res.data?.token) {
            context.actions.setApiToken(res.data.token)
            window.apiToken = res.data.token
            
            const response = await api.authCheck()
            console.log(response)
            if (response) {
              context.actions.setUser(response.data)
              context.actions.setOwnerUser(response.data.owner)
            }
            if (!response) console.log('nope')
          }
        } catch (error) {

          context.actions.setErrorMessage(error.response?.status)
          context.actions.setModalState({ ...context.modalState, disconnect: true })
        }
      }
    }

    connectToFms()
    fetchMaps()

  }, [context.firstLoad])*/

  return (
    <div className="is-flex is-vcentered is-justify-between mb-5 py-2" style={{ flexWrap: 'wrap', borderBottom: '1px solid #e1e1e1' }}>
      <div className="is-pulled-left">
        {!context.settings.fmsConnection &&
          <button
            className="button is-link is-active mr-2 mb-2 is-pulled-left"
            onClick={() => context.actions.setModalState({ ...context.modalState, configuration: true })}
          >

            <FontAwesomeIcon icon={faRobot} className="is-small mr-2" />
            Robôs
          </button>
        }
        <button
          className="button is-link is-active mr-2 mb-2 is-pulled-left"
          onClick={() => context.actions.setModalState({ ...context.modalState, settingsRemote: !context.modalState.settingsRemote })}
        >
          <FontAwesomeIcon icon={faCog} className="fas  mr-2" />
          Definições
        </button>
      </div>

      {!context.settings.fmsConnection && <RobotSelector />}
    </div>
  );
}
